import React, { useState, useEffect, useRef } from "react"
import Box from "@mui/material/Box"
import {
    CFooter
} from "@coreui/react"
import { HomeOutlined, ChatBubbleOutline, Category, CategoryOutlined, AccountCircleOutlined } from "@mui/icons-material"
import { Grid, Typography } from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom"
import { FOOTER_TAB_INDEX } from "src/utils/enum"

export const Footer = ({ activeIndex = 0 }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const activeColor = "red";

    const onClickIndex = (index) => {
        const { pathname } = location;

        if (index === FOOTER_TAB_INDEX.HOME) {
            if(pathname !== "/") {
                navigate("/");
            }
        } else if (index === FOOTER_TAB_INDEX.CHAT) {
            if(pathname !== "/chat") {
                navigate("/chat");
            }
        } else if (index === FOOTER_TAB_INDEX.CATEGORY) {
            if(pathname !== "/category") {
                navigate("/category");
            }
        } else if (index === FOOTER_TAB_INDEX.MY_ACOUNT) {
            if(pathname !== "/my-acount") {
                navigate("/my-account");
            }
        }
    }

    return (
        <CFooter position="sticky" className="footer-div border-top-0">
            <Box className="footer-inner-div d-flex" sx={{
                backgroundColor: "#ffffff",
                width: "100%",
                paddingLeft: "20px",
                paddingRight: "20px"
            }}>
                <Grid container columns={{ xs: 12, lg: 12 }} spacing={{ xs: 2, lg: 2 }}>
                    <Grid item xs={3} lg={3} >
                        <Box className="footer-div" onClick={() => {
                            onClickIndex(0)
                        }}>
                            <Box className="d-flex justify-content-center">
                                <HomeOutlined className="footer-icon"
                                    sx={
                                        activeIndex === FOOTER_TAB_INDEX.HOME ? {
                                            color: activeColor
                                        } : null
                                    }
                                />
                            </Box>
                            <Box className="d-flex justify-content-center">
                                <Typography
                                    variant="paragraph"
                                    className="footer-text"
                                    sx={
                                        activeIndex === FOOTER_TAB_INDEX.HOME ? {
                                            color: activeColor
                                        } : null
                                    }
                                >
                                    Home
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={3} lg={3}>
                        <Box className="footer-div" onClick={() => {
                            onClickIndex(1)
                        }}>
                            <Box className="d-flex justify-content-center">
                                <ChatBubbleOutline className="footer-icon"
                                    sx={
                                        activeIndex === FOOTER_TAB_INDEX.CHAT ? {
                                            color: activeColor
                                        } : null
                                    }
                                />
                            </Box>
                            <Box className="d-flex justify-content-center">
                                <Typography
                                    variant="paragraph"
                                    className="footer-text"
                                    sx={
                                        activeIndex === FOOTER_TAB_INDEX.CHAT ? {
                                            color: activeColor
                                        } : null
                                    }
                                >
                                    Chat
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={3} lg={3}>
                        <Box className="footer-div" onClick={() => {
                            onClickIndex(2)
                        }}>
                            <Box className="d-flex justify-content-center">
                                <CategoryOutlined className="footer-icon"
                                    sx={
                                        activeIndex === FOOTER_TAB_INDEX.CATEGORY ? {
                                            color: activeColor
                                        } : null
                                    }
                                />
                            </Box>
                            <Box className="d-flex justify-content-center">
                                <Typography
                                    variant="paragraph"
                                    className="footer-text"
                                    sx={
                                        activeIndex === FOOTER_TAB_INDEX.CATEGORY ? {
                                            color: activeColor
                                        } : null
                                    }
                                >
                                    Categories
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={3} lg={3}>
                        <Box className="footer-div" onClick={() => {
                            onClickIndex(3)
                        }}>
                            <Box className="d-flex justify-content-center">
                                <AccountCircleOutlined className="footer-icon"
                                    sx={
                                        activeIndex === FOOTER_TAB_INDEX.MY_ACOUNT ? {
                                            color: activeColor
                                        } : null
                                    }
                                />
                            </Box>
                            <Box className="d-flex justify-content-center">
                                <Typography
                                    variant="paragraph"
                                    className="footer-text"
                                    sx={
                                        activeIndex === FOOTER_TAB_INDEX.MY_ACOUNT ? {
                                            color: activeColor
                                        } : null
                                    }
                                >
                                    My Account
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </CFooter>
    )
}

export default Footer
